export default "__VITE_ASSET__CP01VYqz__"